import { FaGithub, FaLinkedin, FaEnvelope, FaFileDownload } from 'react-icons/fa';
import { useLang } from '../../context/LangContext';
import './Footer.css';

export default function Footer() {
  const { t, lang } = useLang();
  const f = t.footer;
  const cvFile = lang === 'pt' ? 'Curriculo_PT-BR_Alan_Souza.pdf' : 'Resume_EN_Alan_Souza.pdf';
  const cvUrl = `${process.env.PUBLIC_URL}/${cvFile}`;

  const handleDownload = (event) => {
    event.preventDefault();

    const link = document.createElement('a');
    link.href = cvUrl;
    link.download = cvFile;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.open(cvUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-socials">
          <a href="mailto:alansouzaesi@gmail.com" className="footer-link" aria-label="E-mail" target="_blank" rel="noopener noreferrer">
            <FaEnvelope />
          </a>
          <a href="https://www.linkedin.com/in/alanvasconi/" className="footer-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
            <FaLinkedin />
          </a>
          <a href="https://github.com/Alan-VSouza" className="footer-link" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
            <FaGithub />
          </a>
          <a href={cvUrl} className="footer-link footer-link--cv" aria-label={f.cvLabel} title={f.cvLabel} onClick={handleDownload}>
            <FaFileDownload />
          </a>
        </div>
        <div className="footer-credit">
          <span>© {new Date().getFullYear()} <span className="footer-name">Alan Souza</span></span>
          <span className="footer-dot"> • </span>
          <span className="footer-built">{f.built}</span>
        </div>
      </div>
    </footer>
  );
}